/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  createDialogRoute,
  FormState,
  FormStateBuilder,
  getDialogInitData,
  whenCreateOrEditMode,
} from '@gh/common-shared';
import { AutocompleteLoadMoreEvent, DialogInput, FormMode } from '@gh/core-ui';
import { assign } from 'lodash';
import { JobSpecCreateBusinessService, JobSpecTemplateFinder } from '../../resources';
import { map$ } from '@gh/rx/operators';
import { ID } from '@gh/common-shared-data';

export interface JobSpecCreateDialogConfig {
  isFromCreateBtn: boolean;
  jobId?: ID;
}

@Component({
  standalone: false,
  selector: 'gh-spec-create-dialog',
  templateUrl: 'job-spec-create-dialog.component.html',
  styleUrls: ['job-spec-create-dialog.component.scss'],
})
export class JobSpecCreateDialogComponent implements OnInit, DialogInput<JobSpecCreateDialogConfig> {
  input: JobSpecCreateDialogConfig;
  form: FormState<JobSpecTemplateFinder>;
  loadedJobs: any[] = [];
  constructor(private dialogRef: MatDialogRef<any>,
              private formStateBuilder: FormStateBuilder,
              @Inject(MAT_DIALOG_DATA) private dialogData: any,
              private businessService: JobSpecCreateBusinessService) {
  }

  ngOnInit(): void {
    assign(this, getDialogInitData(this.dialogData));

    this.form = this.formStateBuilder.buildPlain({
      value: {
        jobId: this.input.jobId,
      },
      mode: FormMode.CreateMode,
      enabled: whenCreateOrEditMode(),
      children: {
        jobId: { visible: this.input.isFromCreateBtn, required: true },
        jobSpecTemplate: { required: true },
      },
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onApply(): void {
    if (this.form.group.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const targetJob = this.loadedJobs.find((job) => job.id === this.form.get('jobId').value);
    this.dialogRef.close({...this.form.group.value, forDpp: !!targetJob && !!targetJob.isDpp });
  }

  loadJobSpecTemplates($event: AutocompleteLoadMoreEvent): void {
    $event.load(this.businessService.findAllAsDataSource($event.query));
  }

  loadJobs(event: AutocompleteLoadMoreEvent): void {
    event.load(this.businessService.findAllJobs(event.query)
                 .pipe(map$((res) => {this.loadedJobs = [...this.loadedJobs, ...res]; return res; })));
  }
}

export const jobSpecCreateDialogRoute = createDialogRoute({
  component: JobSpecCreateDialogComponent,
  config: { disableClose: true },
});
